// extracted by mini-css-extract-plugin
export default {"groupCard":"styles_groupCard__lBd2A","details":"styles_details__AEqpZ","icon":"styles_icon__+O9Xf","img":"styles_img__tAqH7"};